import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {RouteUrls} from '../../shared/constants/RouteUrls';

@Component({
  selector: 'app-permission-path',
  templateUrl: './permission-path.component.html',
  styleUrls: ['./permission-path.component.scss']
})
export class PermissionPathComponent {

  constructor(router: Router) {
    router.navigate([`/${RouteUrls.DASHBOARD.MODULE_BASE}`]);
  }
}
